/** "Bebidas Quentes & Cafés" → "bebidas-quentes-cafes". */
export function slugify(text: string): string {
    return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

/**
 * Extrai o id numérico de um slug — "{id}-{texto}" OU "{texto}-{id}" (o
 * details.slug do backend traz o id no fim: "kit-cafe-...-980019"). O texto é
 * só cosmético/SEO — a navegação resolve pelo id. Retorna 0 sem id válido.
 */
export function parseIdFromSlug(slug: string): number {
    const fromStart = Number.parseInt(slug, 10);
    if (Number.isFinite(fromStart) && fromStart > 0) return fromStart;

    const fromEnd = slug.match(/-(\d+)$/)?.[1];
    return fromEnd ? Number.parseInt(fromEnd, 10) : 0;
}
